<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <v-textarea
          v-model="item.explanation"
          label="توضیحات"
          outlined
          rows="3"
          class="mt-4"
        ></v-textarea>
      </v-col>
      <v-col cols="12" md="12">
        <v-switch v-if="isPackage" label="انتخاب به عنوان محبوب ترین انتخاب" v-model="item.highlight" />
      </v-col>
    </v-row>
    <v-divider class="my-4" />
    <h4 class="mb-3 subtitle-1">قیمت‌گذاری (ریال)</h4>
    
    <v-row v-for="(price, period) in item.prices" :key="period" class="mb-2" align="center">
      <v-col cols="12" sm="3"><strong>{{ translatePeriod(period) }}</strong></v-col>
      <v-col cols="12" sm="3">
        <money
          v-model="price.original_price"
          label="قیمت اصلی"
          outlined
          dense
          @input="$emit('recalculate', item, period)"
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model.number="price.discount_percentage"
          label="تخفیف (٪)"
          type="number" min="0" max="100" outlined dense
          @input="$emit('recalculate', item, period)"
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <money
          v-model="price.final_price"
          label="قیمت نهایی"
          readonly outlined dense filled
          hide-details="auto"
        />
      </v-col>
    </v-row>

    <v-divider class="my-4" />
    <div class="d-flex justify-space-between align-center mb-3">
      <h4 class="subtitle-1">امکانات</h4>
      <v-btn small color="primary" outlined @click="item.features.push('')">
        <v-icon left small>fa-plus</v-icon>
        افزودن امکان
      </v-btn>
    </div>
    <v-row v-for="(feature, i) in item.features" :key="i" align="center">
      <v-col cols="11">
        <v-text-field
          v-model="item.features[i]"
          label="متن امکان"
          outlined
          dense
          hide-details="auto"
          class="mb-2 text-right"
        />
      </v-col>
      <v-col cols="1" class="text-center">
        <v-btn icon color="error" @click="item.features.splice(i, 1)">
          <v-img class="ml-1" max-width="30" src="/img/icons/delete.svg"></v-img>
        </v-btn>
      </v-col>
    </v-row>

    <v-divider class="mt-6 mb-4" />
    <v-card-actions>
      <v-spacer />
      <v-btn large color="success" @click="$emit('save', item)">
        <v-icon left>fa-check-circle</v-icon>
        ذخیره تغییرات
      </v-btn>
    </v-card-actions>
  </div>

</template>

<script>
import Money from '@/components/mcomponents/cleave/Money.vue';
export default {
  components: {
    Money,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isPackage: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    translatePeriod(p) {
      return {
        monthly: "ماهانه",
        yearly: "سالانه",
        six_monthly: "شش ماهه",
        permanent: "دائمی",
      }[p] || p;
    },
  },
};

</script>